import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import CallSubmissionInterface from './pages/call-submission-interface';
import BuyerBidManagementInterface from './pages/buyer-bid-management-interface';
import BuyerRegistrationProfileManagement from './pages/buyer-registration-profile-management';
import RevenueAnalyticsReportingDashboard from './pages/revenue-analytics-reporting-dashboard';
import RealTimeBiddingEngineDashboard from './pages/real-time-bidding-engine-dashboard';
import PublisherDashboard from './pages/publisher-dashboard';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<BuyerBidManagementInterface />} />
        <Route path="/call-submission-interface" element={<CallSubmissionInterface />} />
        <Route path="/buyer-bid-management-interface" element={<BuyerBidManagementInterface />} />
        <Route path="/buyer-registration-profile-management" element={<BuyerRegistrationProfileManagement />} />
        <Route path="/revenue-analytics-reporting-dashboard" element={<RevenueAnalyticsReportingDashboard />} />
        <Route path="/real-time-bidding-engine-dashboard" element={<RealTimeBiddingEngineDashboard />} />
        <Route path="/publisher-dashboard" element={<PublisherDashboard />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
